var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      staticClass: "shortcut-overview-modal",
      attrs: { size: "normal", title: _vm.$t("calendar", "Shortcut overview") },
      on: {
        close: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    _vm._l(_vm.shortcuts, function(category) {
      return _c(
        "section",
        { key: category.categoryId, staticClass: "shortcut-section" },
        [
          _c("h3", { staticClass: "shortcut-section__header" }, [
            _vm._v("\n\t\t\t" + _vm._s(category.categoryLabel) + "\n\t\t")
          ]),
          _vm._v(" "),
          _vm._l(category.shortcuts, function(shortcut, index) {
            return _c(
              "div",
              {
                key: category.categoryId + "-" + index,
                staticClass: "shortcut-section-item"
              },
              [
                _c(
                  "span",
                  { staticClass: "shortcut-section-item__keys" },
                  [
                    _vm._l(shortcut.keys, function(keyCombination, index2) {
                      return [
                        _vm._l(keyCombination, function(key, index3) {
                          return [
                            _c(
                              "kbd",
                              {
                                key:
                                  category.categoryId +
                                  "-" +
                                  index +
                                  "-" +
                                  index2 +
                                  "-" +
                                  index3
                              },
                              [_vm._v(_vm._s(key))]
                            ),
                            _vm._v(" "),
                            index3 !== keyCombination.length - 1
                              ? _c(
                                  "span",
                                  {
                                    key:
                                      category.categoryId +
                                      "-" +
                                      index +
                                      "-" +
                                      index2 +
                                      "-" +
                                      index3,
                                    staticClass: "shortcut-section-item__spacer"
                                  },
                                  [_vm._v("\n\t\t\t\t\t\t\t+\n\t\t\t\t\t\t")]
                                )
                              : _vm._e()
                          ]
                        }),
                        _vm._v(" "),
                        index2 !== shortcut.keys.length - 1
                          ? _c(
                              "span",
                              {
                                key:
                                  category.categoryId +
                                  "-" +
                                  index +
                                  "-" +
                                  index2,
                                staticClass: "shortcut-section-item__spacer"
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(_vm.t("calendar", "or")) +
                                    "\n\t\t\t\t\t"
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("span", { staticClass: "shortcut-section-item__label" }, [
                  _vm._v(_vm._s(shortcut.label))
                ])
              ]
            )
          })
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }